module.exports = __webpack_public_path__ + "img/community09.f929c19b.png";